import React, { useRef, useEffect } from "react";
import styled, { css } from "styled-components/macro";
import { BsFillXOctagonFill } from "react-icons/bs";

const FormComponents = (props) => {
  const {
    id = "",
    compType = "",
    type = "",
    disabled = false,
    value = "",
    options = [],
    onChange = () => null,
    allowMultipleFile = false,
    accept = "",
    min,
    error = "",
   affixLabel = "",
    onKeyDown
  } = props;

  const fileInputRef = useRef(null);
  
  useEffect(() => {
    if (type === "file") {
      if (fileInputRef && fileInputRef.current && !value) {
        fileInputRef.current.value = "";
      }
    }
  }, [value]);
  
  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();

  if (typeof compType === "function") {
    return compType(props);
  } else if (compType === "input" && type !== "checkbox") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <StyledInput
            id={`input_${id}`}
            type={type ? type : "text"}
            value={value}
            min={min}
            onChange={(event) => onChange(id, event.target.value, event)}
            disabled={disabled}
            onKeyDown={onKeyDown ? (event) => onKeyDown(id, event.code, event) : type === "number" ? blockInvalidChar : undefined}
            error={error}
            autoComplete="off"
          />
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{error}</p></ FormErrorSectionDiv> : null}
        </MultiTagWrapper>
          {/* <FormErrorSectionDiv>
            {error ? <BsFillXOctagonFill /> : null }
          </FormErrorSectionDiv> */}
          {affixLabel ? <label id="affixLabel">{affixLabel}</label> : null}
      </StyledWrapper>
    );
  } else if (compType === "input" && type === "checkbox") {
    return (
      <StyledWrapper>
        <StyledInput
          id={`input_${id}`}
          type="checkbox"
          checked={value}
          onChange={(event) => onChange(id, event.target.checked, event)}
          disabled={disabled}
        />
        {error ? (
          <FormErrorSectionDiv>
            <BsFillXOctagonFill />
          </FormErrorSectionDiv>
        ) : null}
      </StyledWrapper>
    );
  } else if (compType === "dropdown") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <StyledSelect
            id={id}
            name={id}
            value={value}
            onChange={(event) => onChange(id, event.target.value, event)}
            error={error}
            disabled={disabled}
          >
            {options.length
              ? options.map((item) => (
                  <option key={`${id}_${item.value}`} value={item.value}>
                    {item.label}
                  </option>
                ))
              : null}
          </StyledSelect>
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{error}</p></FormErrorSectionDiv> : null}
        </MultiTagWrapper>
        {/* {error ? (
          <FormErrorSectionDiv>
            <BsFillXOctagonFill />
          </FormErrorSectionDiv>
        ) : null} */}
      </StyledWrapper>
    );
  } else if (compType === "file") {
    return (
      <StyledWrapper>
        <MultiTagWrapper>
          <StyledInput type="text" value={value} error={error} disabled={disabled}/>
          {error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{error}</p></FormErrorSectionDiv> : null}
        </MultiTagWrapper>
        <StyledInput
          id={`input_${id}`}
          name={`input_${id}`}
          type="file"
          ref={fileInputRef}
          accept={accept}
          onChange={(event) =>
            onChange(id, Array.from(event.target.files), event)
          }
          disabled={disabled}
          multiple={allowMultipleFile}
        />
          {/* <FormErrorSectionDiv>
            {
              error ? <BsFillXOctagonFill /> : null
            }
          </FormErrorSectionDiv> */}
        <UploadButton
          for={`input_${id}`}
          error={error}
          disabled={disabled}>
            Choose File
        </UploadButton>
      </StyledWrapper>
    );
  } else {
    return null;
  }
};

export default FormComponents;

export const StyledSelect = styled.select`
  width: 330px;
  height: 28px;
  border: 1px solid #a9a9a9;
  cursor: pointer;
  color: #333;
  padding-left: 2px;
  font-size: 1rem;
  font-family: Verdana;
  border-radius: 4px;
  option {
    height: 25px;
  }
  &:focus,
  :focus-visible {
    outline: none;
  }
  ${(props) =>
    props.error
      ? css`
          border-color: #C31200; background-color: #fbf4f4;
        `
      : ""}
`;

export const StyledInput = styled.input`
  width: 330px;
  height: 28px !important;
  border: 1px solid #a9a9a9 !important;
  color: #333;
  padding-left: 5px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-size: 1rem !important;
  font-family: Verdana;
  border-radius: 4px;
  &:disabled {
    border-color: #babfc7 !important;
    color: #898989;
    background-color: #fff;
  }
  &:focus,
  :focus-visible {
    outline: none;
  }
  ${(props) =>
    props.error
      ? css`
          border-color: #C31200 !important; background-color: #fbf4f4 !important;
        `
      : ""}
`;

export const MultiTagWrapper = styled.div`
  height: 47px;
  #cert-name {
    /* min-width: 100px; */
    padding-top: 5px;
    padding-right: 15px;
  }
  > p {
    color: #C31200;
    font-size: 10px;
    font-style: italic;
    margin-top: 3px;
  }
  // To hide up/down arrow for number fields
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  > label#affixLabel {
    margin-bottom: 20px;
    margin-left: 10px;
    font-family: Verdana;
  }
`;

export const FormErrorSectionDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    color: #C31200;
    margin-left: 3px;
    font-size: 11px;
    margin-right: 5px;
    margin-top: 2px;
  }
  > p {
    color: #C31200;
    font-size: 10px;
    margin-top: 3px;
  }
`;

export const UploadButton = styled.label`
  margin-bottom: 19px;
  width: 100px;
  height: 25px;
  background: #e0e0e0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid gray;
  border-radius: 3px;
  margin-left: ${ props => (props.ml ? props.ml : "17px") };
  cursor: pointer;
  font-size: 1rem;
  font-family: Verdana;
  /* ${(props) => props.error ? css`margin-bottom: 13px;` : ""} */
  ${(props) => props.disabled ? css`color: #898989; border-color: #babfc7;` : ""}
`;

